/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { assetImages } from "constants";

import * as url from "helper/UrlHelper";

const CommunityRightPanel = ({
  setTagFourmId,
  forumId,
  setforumId,
  title,
  description,
  forumTimeAgo,
  moderatorId,
  moderatorImage,
  moderatorName,
  detailsLoading,
  likeCount,
  commentCount,
  commentList,
  toggleLikeForum,
  onEditComment,
  onDeleteComment,
  winnerHandler,
  topCommentId,
  winnerId,
  toggleLikeComment,
  isPrivate,
  setEditedForumId,
  uploadedFiles,
  tags,
  deletePostHandler,
}) => {
  const token = localStorage.getItem("token");

  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  if (forumId) {
    return (
      <div className="col-lg-7">
        <div className="activity_rightpnl p-4 rounded-16 bg-white">
          <div className="activity_backBtn">
            <Link
              to="#"
              onClick={() => {
                document.body.classList.remove("activity_open");
              }}
              className="d-flex align-items-center gap-2"
            >
              <i className="material-icons-outlined">arrow_back</i>
              <span>Back</span>
            </Link>
          </div>
          <div className="pnl_innr">
            {/* placeholder */}

            {detailsLoading ? (
              <div className="activity_rightItem pt-0">
                <div className="glow_area">
                  <div className="plan rounded-3 placeholder-glow">
                    <div className="user_placeHoledr d-flex align-items-center gap-3 mb-4">
                      <div
                        className="default_usr placeholder rounded-circle"
                        style={{
                          height: "30px",
                          width: "30px",
                          minWidth: "30px",
                        }}
                      >
                        <img src="images/default-user.png" alt="" />
                      </div>
                      <div
                        className="default_usr_name"
                        style={{ width: "200px" }}
                      >
                        <span className="placeholder placeholder-sm d-block rounded-3"></span>
                      </div>
                    </div>
                    <span className="placeholder placeholder-sm d-block mb-3"></span>
                    <p className="card-text placeholder-glow mb-4">
                      <span className="placeholder placeholder-sm col-12 rounded-3"></span>
                      <span className="placeholder placeholder-sm col-10 rounded-3"></span>
                      <span className="placeholder placeholder-sm col-9 rounded-3"></span>
                      <span className="placeholder placeholder-sm col-8 rounded-3"></span>
                    </p>
                    <div className="data_btnOuter">
                      <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                      <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                      <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                      <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                      <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                      <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                      <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                      <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                      <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                      <span className="placeholder placeholder-sm col-2 rounded-3"></span>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="activity_rightItem pt-0">
                <div className="option_drops_activity d-flex align-items-center justify-content-between mb-3">
                  <div className="activity_userOuter d-flex align-items-center gap-2">
                    <div className="activity_usrPnl d-flex align-items-center gap-2">
                      <div className="user_activty rounded-circle overflow-hidden">
                        <img
                          src={
                            moderatorImage == ""
                              ? assetImages.defaultUser
                              : url.SERVER_URL + moderatorImage
                          }
                          alt=""
                        />
                      </div>
                      <div className="activty_usrname">
                        <h4 className="text-black fs-md fw-bold">
                          {moderatorName}
                        </h4>
                      </div>
                    </div>
                    <div className="activity_date d-flex align-items-center gap-2 fs-sm text-black">
                      <span>{forumTimeAgo}</span>
                    </div>
                  </div>

                  <div className="more_option dropdown">
                    {token && (
                      <Link to="#" data-bs-toggle="dropdown">
                        <span className="d-block material-icons-outlined text-black">
                          more_vert
                        </span>
                      </Link>
                    )}
                    <ul className="list_style_none dropdown-menu">
                      {moderatorId ? (
                        moderatorId?.toString() == userInfo?._id?.toString() ||
                        userInfo?.role?.name == "Admin" ? (
                          <li>
                            <Link
                              to="#"
                              data-bs-toggle="modal"
                              data-bs-target={
                                token ? "#question_modal" : "#login_modal"
                              }
                              onClick={() => {
                                setEditedForumId(forumId);
                              }}
                            >
                              Edit Post
                            </Link>
                          </li>
                        ) : null
                      ) : null}
                      {moderatorId ? (
                        moderatorId?.toString() == userInfo?._id.toString() ||
                        userInfo?.role?.name == "Admin" ? (
                          <li>
                            <Link to="#" onClick={deletePostHandler}>
                              Delete Post
                            </Link>
                          </li>
                        ) : null
                      ) : null}

                      {token && (
                        <li>
                          <Link
                            to="#"
                            data-bs-toggle="modal"
                            data-bs-target="#addtag_mdl"
                            onClick={() => {
                              setTagFourmId(forumId);
                            }}
                          >
                            Add Tag
                          </Link>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>

                {/* title */}
                <div className="activity_rightHdng mb-3">
                  <h3 className="text-primary fw-bold fs-xl">{title}</h3>
                </div>

                {/* details */}
                <div className="activity_para mt-3 mb-3">
                  <p dangerouslySetInnerHTML={{ __html: description }}></p>
                </div>

                {/* uploaded files */}
                {uploadedFiles.map((file, index) => {
                  return (
                    <div className="details_pic mb-4" key={index}>
                      <img src={url.SERVER_URL + file.path} alt="" />
                    </div>
                  );
                })}

                {/* like,comment,winner */}
                <div className="winers_likeOuter d-flex align-items-center mt-3 mb-3 gap-2 flex-wrap">
                  <div className="action d-flex align-items-center gap-2">
                    <Link
                      onClick={() => {
                        if (token) {
                          toggleLikeForum();
                        }
                      }}
                      to="#"
                      className="btn white_btn text-black px-3 py-2 d-inline-flex align-items-center gap-2 rounded-4"
                    >
                      <span className="d-block material-icons-outlined fs-lg">
                        thumb_up
                      </span>
                      <span className="d-block">Likes</span>
                      <span
                        className="d-flex align-items-center justify-content-center bg-pink text-white rounded-90"
                        style={{
                          minWidth: "1.325rem",
                          height: "1.4rem",
                        }}
                      >
                        {likeCount}
                      </span>
                    </Link>
                    <Link
                      to="#"
                      className="btn white_btn text-black px-3 py-2 d-inline-flex align-items-center gap-2 rounded-4"
                    >
                      <span className="d-block material-icons-outlined fs-lg">
                        comment
                      </span>
                      <span className="d-block">comment</span>
                      <span
                        className="d-flex align-items-center justify-content-center bg-pink text-white rounded-90"
                        style={{
                          minWidth: "1.325rem",
                          height: "1.4rem",
                        }}
                      >
                        {commentCount}
                      </span>
                    </Link>
                  </div>
                  <div className="winner_tags btn d-inline-flex align-items-center gap-2 justify-content-center primary-btn px-3 py-2 rounded-4 overflow-hidden">
                    <i className="material-icons-outlined fs-lg">verified</i>
                    <span>Winner</span>
                  </div>
                </div>

                {/* tags */}
                {tags.length > 0 ? (
                  <div className="activity_tagsouter">
                    <div className="activity_tagsRow mb-3">
                      <h4 className="text-black fs-sm fw-bold mb-2">Tags</h4>
                      <div className="experts_skill activity_skill d-flex gap-2">
                        <ul className="list_style_none d-flex align-items-center gap-2 flex-wrap">
                          {tags.map((tag, index) => {
                            return (
                              <li key={index}>
                                <Link
                                  to="#"
                                  className="d-flex align-items-center py-2 px-3 bg-white rounded-4 fs-sm"
                                >
                                  {tag.title}
                                </Link>
                              </li>
                            );
                          })}
                        </ul>
                        {tags.length > 4 ? (
                          <div className="more_tags">
                            <Link
                              to="#"
                              className="d-flex align-items-center py-2 px-3 text-black rounded-4 fs-sm"
                            >
                              +{tags.length - 4}
                            </Link>
                          </div>
                        ) : null}
                      </div>
                    </div>

                    {/* <div className="activity_tagsRow">
                  <h4 className="text-black fs-sm fw-bold mb-2">Categories </h4>
                  <div className="experts_skill activity_skill d-flex  gap-2">
                    <ul className="list_style_none d-flex align-items-center gap-2 flex-wrap">
                      <li>
                        <Link
                          to="#"
                          className="d-flex align-items-center py-2 px-3 bg-white rounded-4 fs-sm"
                        >
                          Backend
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="d-flex align-items-center py-2 px-3 bg-white rounded-4 fs-sm"
                        >
                          Data analyst
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="d-flex align-items-center py-2 px-3 bg-white rounded-4 fs-sm"
                        >
                          Data
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="d-flex align-items-center py-2 px-3 bg-white rounded-4 fs-sm"
                        >
                          Load
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="#"
                          className="d-flex align-items-center py-2 px-3 bg-white rounded-4 fs-sm"
                        >
                          Data science
                        </Link>
                      </li>
                    </ul>
                    <div className="more_tags">
                      <Link
                        to="#"
                        className="d-flex align-items-center py-2 px-3 text-black rounded-4 fs-sm"
                      >
                        +4
                      </Link>
                    </div>
                  </div>
                </div> */}
                  </div>
                ) : null}
                {/* <div className="pt-4 activity_comments">
                <div className="form_commnts_area body_bg  position-relative overflow-hidden">
                  <textarea
                    className="form-control"
                    placeholder="Write your query here"
                  ></textarea>
                  <div className="furmcmnt_btn d-flex align-items-center justify-content-end">
                    <button className="cmnt_btn position-relative">
                      <input type="file" className="file_btn" />
                      <span className="material-icons-outlined fs-lg text-black">
                        image
                      </span>
                    </button>
                    <button className="cmnt_btn">
                      <span className="material-icons-outlined fs-lg text-black">
                        send
                      </span>
                    </button>
                  </div>
                </div>
              </div> */}

                {token ? (
                  <div className="pt-4 activity_comments">
                    <div className="top_usr_srch commnts_user_fill d-flex align-items-center gap-2">
                      <div className="team_usr_pic search_profile rounded-circle overflow-hidden">
                        <img
                          src={
                            userInfo.photoimage
                              ? userInfo.photoimage.path == ""
                                ? assetImages.defaultUser
                                : url.SERVER_URL + userInfo.photoimage.path
                              : assetImages.defaultUser
                          }
                          alt=""
                        />
                      </div>
                      <div
                        className="search_fill comment_search w-100 position-relative rounded-90 overflow-hidden"
                        data-bs-toggle="modal"
                        data-bs-target="#activity_mdl"
                      >
                        <input
                          type="text"
                          className="form-control border-0 body_bg px-3"
                          placeholder="Your reply"
                        />
                        <button className="emoji_btn position-absolute border-0 p-0">
                          <i className="material-icons-outlined fs-lg text-black">
                            send
                          </i>
                        </button>
                      </div>
                    </div>
                  </div>
                ) : null}
              </div>
            )}

            {/* comment section */}
            <div className="activity_rightItem pb-0">
              {commentList.map((commentData, index) => {
                return (
                  <div
                    className={
                      topCommentId &&
                      topCommentId.toString() === commentData._id.toString()
                        ? "forum_row active_forum"
                        : "forum_row"
                    }
                    key={index}
                  >
                    <div className="forum_cmntsRow  position-relative d-flex align-items-center justify-content-between">
                      <div className="team_userOuter forum_usrOuter d-flex gap-2 w-100">
                        <div className="team_usr_pic rounded-circle overflow-hidden">
                          <img
                            src={
                              commentData.commentownerimage == ""
                                ? assetImages.defaultUser
                                : url.SERVER_URL + commentData.commentownerimage
                            }
                            alt=""
                          />
                        </div>
                        <div className="team_usrTxt w-100">
                          <div className="d-flex align-items-start justify-content-between w-100">
                            <div className="name_left">
                              <h4 className="text-black fs-md fw-bold mb-1">
                                {commentData.commentownername}
                              </h4>
                              <h5 className="fs-sm text-black">
                                {commentData.commenttimestring}
                              </h5>
                            </div>
                            {userInfo?.role?.name == "Admin" ||
                            userInfo?._id.toString() ===
                              moderatorId.toString() ||
                            userInfo?._id.toString() ===
                              commentData?.userid._id.toString() ? (
                              <div className="more_btn dropdown">
                                <Link
                                  to="#"
                                  className="d-inline-block"
                                  data-bs-toggle="dropdown"
                                >
                                  <span className="material-icons-outlined fs-lg text-black">
                                    more_vert
                                  </span>
                                </Link>
                                <ul className="dropdown-menu">
                                  <li>
                                    <Link
                                      to="#"
                                      data-bs-toggle="modal"
                                      data-bs-target="#activity_mdl"
                                      onClick={() => {
                                        onEditComment(commentData._id);
                                      }}
                                    >
                                      Edit comments
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => {
                                        onDeleteComment(commentData._id);
                                      }}
                                    >
                                      Delete
                                    </Link>
                                  </li>
                                  {moderatorId ? (
                                    userInfo?.role?.name == "Admin" ||
                                    moderatorId?.toString() ===
                                      userInfo?._id.toString() ? (
                                      <li>
                                        <Link
                                          to="#"
                                          onClick={() => {
                                            winnerHandler(
                                              commentData._id,
                                              commentData.userid._id
                                            );
                                          }}
                                        >
                                          Set Winner
                                        </Link>
                                      </li>
                                    ) : null
                                  ) : null}
                                </ul>
                              </div>
                            ) : null}
                          </div>

                          <div className="forum_para mt-3">
                            <p>{commentData.description}</p>
                          </div>

                          <div className="winers_likeOuter d-flex align-items-center mt-3 mb-3 gap-2 flex-wrap">
                            <div className="action d-flex align-items-center gap-2">
                              <Link
                                onClick={() => {
                                  if (token) {
                                    toggleLikeComment(commentData._id);
                                  }
                                }}
                                to="#"
                                className="btn body-bg text-black px-3 py-2 d-inline-flex align-items-center gap-2 rounded-4"
                              >
                                <span className="d-block material-icons-outlined fs-lg">
                                  thumb_up
                                </span>
                                <span className="d-block">Likes</span>
                                <span
                                  className="d-flex align-items-center justify-content-center bg-pink text-white rounded-90"
                                  style={{
                                    minWidth: "1.325rem",
                                    height: "1.4rem",
                                  }}
                                >
                                  {commentData.likeids.length}
                                </span>
                              </Link>
                              {/* <Link
                                to="#"
                                className="btn body-bg text-black px-3 py-2 d-inline-flex align-items-center gap-2 rounded-4"
                              >
                                <span className="d-block material-icons-outlined fs-lg">
                                  comment
                                </span>
                                <span className="d-block">comment</span>
                                <span
                                  className="d-flex align-items-center justify-content-center bg-pink text-white rounded-90"
                                  style={{
                                    minWidth: "1.325rem",
                                    height: "1.4rem",
                                  }}
                                >
                                  {commentData.likeids.length}
                                </span>
                              </Link> */}
                            </div>
                            <div className="winner_tags btn d-inline-flex align-items-center gap-2 justify-content-center primary-btn px-3 py-2 rounded-4 overflow-hidden">
                              <i className="material-icons-outlined fs-lg">
                                verified
                              </i>
                              <span>Winner</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
  }
};

export default CommunityRightPanel;
